import styled from 'styled-components'

import TypographySecondary from 'components/Typography/Secondary'
import { textSlicer } from 'utils/textSlicer'

type MemberTextProps = {
    name: string
    role?: string
}

const MemberText = ({ name, role }: MemberTextProps) => {
    const { shortText: shortName } = textSlicer(name, 25)

    let shortRole
    if (role) {
        const { shortText } = textSlicer(role, 25)
        shortRole = shortText
    }

    return (
        <StyledNameWrapper>
            <TypographySecondary value={shortName} size={'small'} semiBold />

            <TypographySecondary value={shortRole} size={'xs-small'} />
        </StyledNameWrapper>
    )
}

export default MemberText

const StyledNameWrapper = styled.div`
    display: flex;
    flex-direction: column;
`
